import { useCallback } from 'react';
import { useAuthStore } from '../stores/authStore';
import { api } from '../lib/api';
import { resolveRole } from '../lib/permissions';

interface LoginResponse {
  ok: boolean;
  token: string;
  user: {
    row_id: string;
    nombre: string;
    nivel_permiso: string;
    rol?: string | null;
  };
}

export function useAuth() {
  const { token, userName, role, setAuth, logout, setRole } = useAuthStore();

  const login = useCallback(
    async (rowId: string, pin: string) => {
      // Server hashes the PIN — send raw 4-digit PIN
      const data = await api.post<LoginResponse>('auth/login', {
        row_id: rowId,
        pin,
      });
      const roleName = resolveRole(data.user.nombre, data.user.rol);
      setAuth(data.token, data.user.row_id, data.user.nombre, roleName);
      return data;
    },
    [setAuth],
  );

  return {
    isAuthenticated: !!token,
    userName,
    role,
    login,
    logout,
    setRole,
  };
}
